import LiveMap from '@/components/orders/new-order/live-map/LiveMap';
import { DISPLAY_OPTIONS } from '@/utils/constants';
import s from '@/components/orders/new-order/live.module.css';
import { MapLayerToggles } from './MapLayerToggles';
import { NotificationBell } from './NotificationBell';
import { MAP_LAYERS } from '../hooks/useMapLayers';

export const LiveMapSection = ({
	isMasterOrAdmin,
	switchDisplay,
	user,
	displayOption,
	mapWidth,
	mapHeight,
	positions,
	shopPositions,
	layers,
	toggleLayer,
	finalActiveOrders,
	activityVisible,
	toggleActivity,
	activityFeed,
}) => {
	return (
		<div className={s.mapColumn}>
			{isMasterOrAdmin && (
				<div className={s.displayButtons}>
					<div className={s.displayButton} onClick={switchDisplay}>
						Προβολή
					</div>
					<div className={s.displayButton} onClick={toggleActivity}>
						{activityVisible ? 'Απόκρυψη χρονολογίου' : 'Χρονολόγιο'}
					</div>
					<NotificationBell />
				</div>
			)}
			{isMasterOrAdmin &&
				user?.cityLocation?.location &&
				displayOption !== DISPLAY_OPTIONS.ORDERS && (
					<div
						className={`${s.mapContainer} relative`}
						style={{ width: mapWidth, height: mapHeight }}
					>
						<MapLayerToggles layers={layers} toggleLayer={toggleLayer} />
						<LiveMap
							initLocation={user?.cityLocation?.location}
							positions={{
								...(layers?.[MAP_LAYERS.DELIVERIES] ? positions || {} : {}),
								...(shopPositions || {}),
							}}
							orders={layers?.[MAP_LAYERS.DESTINATIONS] && finalActiveOrders}
							traffic={layers?.[MAP_LAYERS.TRAFFIC]}
							colorZonesCity={isMasterOrAdmin ? user?.cityLocation : null}
							width={mapWidth}
							height={mapHeight}
							forDeliveries
						/>
					</div>
				)}

			{/* Under the map on every width. The map column is narrow, so the feed
			    gets the same width rather than the form's — and it stays put when the
			    map is hidden, because history is still worth reading then. */}
			{isMasterOrAdmin && activityVisible && (
				<div className={s.activityContainer} style={{ width: mapWidth }}>
					{activityFeed}
				</div>
			)}
		</div>
	);
};
